import { createContext } from "react";
import type { AdornmentPosition } from "./BaseInputV2Adornment.tsx";

type BaseInputV2AdornmentContextValue = {
  position: AdornmentPosition;
  disabled?: boolean;
};

export const BaseInputV2AdornmentContext =
  createContext<BaseInputV2AdornmentContextValue | null>(null);
